import { useEffect, useState } from "react"
import { FormikProvider, useFormik } from "formik";
import { DetailsImageVehicleRow } from "../fields-upload/DetailsImageVehicleRow";
import { IMaintenanceVisualRecord } from "../../../../../types/maintenance-visual-record.type";

type VehicleStartMaintenanceDetailsProps = {
  data: IMaintenanceVisualRecord;
  onClose?: () => void
}
export default function VehicleStartMaintenanceDetails(props: VehicleStartMaintenanceDetailsProps) {
  const [vehicleId, setvehicleId] = useState<string | null>(null);

  const formik = useFormik({
    initialValues: {
      startMaintenance: props.data.photosMaintenance[0].startMaintenance,
      // outras propriedades inicializadas aqui
    },
    onSubmit: (values) => { values; },
    // outras opções do Formik aqui
  });

  useEffect(() => {
    if (props.data !== undefined) { props.data && setvehicleId(vehicleId); }
  }, [props.data, vehicleId]);

  return (
    <div className="fixed inset-0 z-10 bg-black bg-opacity-30 flex justify-center items-center p-4">
      <FormikProvider value={formik}>
        <section
          style={{ backgroundColor: 'rgb(179, 175, 175)' }}
          className=" flex flex-col items-center rounded-md shadow-lg max-w-[90%] md:max-w-2xl mx-auto p-4 max-h-[calc(100vh-4rem)] overflow-auto">
          <h2 className="text-2xl font-semibold mb-4">Detalhes da devolução</h2>
          <div className="flex flex-wrap justify-center">
            {formik.values?.startMaintenance?.map((doc, index) => (
              <div key={index} className={`flex flex-col space-y-2 p-3 my-0 rounded ${index % 2 ? 'bg-gray/5' : 'bg-gray/5'}`}>
                <DetailsImageVehicleRow
                  name={`startMaintenance.${index}`}
                  initialData={doc || {}}
                  prefix="start-maintenance"
                  vehicleId={props.data.vehicleId}
                />
              </div>
            ))}
          </div>
          <button onClick={props.onClose} className="bg-redPrimary text-white w-24 border-black border-opacity-30 shadow-md relative self-end">Fechar</button>
        </section>
      </FormikProvider>
    </div>
  )
}

